const updates = [
  {
    date: '8/11/2026',
    message: 'Updated Skills and Stats Calculators with new tiered system.',
  },
  {
    date: '8/10/2026',
    message: 'Added GMCP to the Guides section.',
  },
  {
    date: '12/24/2025',
    message: 'Added Tames page showing tameable mobs and their requirements.',
  },
  {
    date: '12/22/2025',
    message:
      'Added new mapping tool. This is in beta for now - if you have any feature requests, please submit them on Github.',
  },
  {
    date: '12/22/2025',
    message: 'Added subclass guides.',
  },
  {
    date: '12/11/2025',
    message: 'Added Quests section.',
  },
  {
    date: '11/20/2025',
    message: 'Updated Menu. Added Area Guides from the Area List.',
  },
  {
    date: '10/13/2025',
    message: 'Added Pet Guide',
  },
  {
    date: '10/12/2025',
    message: 'Added Alchemy page with potion recipes.',
  },
  {
    date: '10/5/2025',
    message: 'Updated Areas Page',
  },
  {
    date: '10/1/2025',
    message: 'Updated Stats Calculator Page',
  },
  {
    date: '8/9/2025',
    message: 'Added a page for helping with some common commands and their syntax.',
  },
  {
    date: '8/5/2025',
    message: 'Added a date/time calculator to convert between Merentha time and real time. ',
  },
  {
    date: '8/1/2025',
    message:
      'Removed werewolf as a separate race and made it a checkbox with day/night toggle on only classes and races that can be werewolves. ',
  },
  {
    date: '7/22/2025',
    message:
      'Added new character selector in calculators to allow for multiple characters. Added Warrior specializations to skill calculator. ' +
      'Added more maps for Cab and Wolvesdale.',
  },
  {
    date: '7/5/2025',
    message:
      'Improve map viewer with zoom and pan functionality. Added skill and stat max button, as well as exp max calculation to quickly calculate ' +
      'required experience.',
  },
  {
    date: '1/24/2022',
    message: 'Added stat rolling info and firework messages',
  },
  {
    date: '1/23/2022',
    message: 'Added list of maps',
  },
  {
    date: '1/22/2022',
    message: 'Added basic skill calculator',
  },
  {
    date: '1/13/2022',
    message: 'Added Socials/Emotes list',
  },
  {
    date: '1/9/2022',
    message: 'Copied over guides. These may be really out of date. Looking for help getting these polished up!',
  },
];

export default updates;
